'use strict';
define(function () {

    function Breakpoint() {}

    Breakpoint.size = function () {
        var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        if (window.getComputedStyle(document.getElementById('breakpoint'), '::before').content === '') {
            if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return 'xsmall';
            }
        }
        return window.getComputedStyle(document.getElementById('breakpoint'), '::before')
            .content
            .replace(/\'|\"/g, '');
    };

    return Breakpoint;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/Breakpoint.js